import ScreenReviewQueueList from 'screens/ReviewQueue/List';
import { REVIEW_QUEUE } from './paths';

const reviewQueueRoutes = [
  {
    path: REVIEW_QUEUE.LIST,
    name: 'ReviewQueueList',
    component: ScreenReviewQueueList,
    allowPermissions: ['list_ad_to_review'],
  },
];

export default reviewQueueRoutes;
